import React from "react"
import { Link } from "react-router-dom"
import { t } from '../../components/i18n/i18n'
import back from "../../assets/images/elements/archiveHeader.jpg"
import article1 from "../../assets/images/articles/1.jpg"
import article2 from "../../assets/images/articles/2.jpg"
import article3 from "../../assets/images/articles/3.jpg"
import article4 from "../../assets/images/articles/4.jpg"

export const Resources = () => {
  const articles = [
    {
      id: 'bondarenko-pastoral-vocation',
      titleKey: 'resourceArticle1Title',
      authorKey: 'resourceArticle1Author',
      descriptionKey: 'resourceArticle1Description',
      url: '/resources/pastoral-vocation',
      img: article1
    },
    {
      id: 'miroslav-peiter-how-to-know-the-will-of-God',
      titleKey: 'resourceArticle2Title',
      authorKey: 'resourceArticle2Author',
      descriptionKey: 'resourceArticle2Description',
      url: '/resources/the-gods-will',
      img: article2
    },
    {
      id: 'viacheslav-herasymchuk-formation-of-hehemiah',
      titleKey: 'resourceArticle3Title',
      authorKey: 'resourceArticle3Author',
      descriptionKey: 'resourceArticle3Description',
      url: '/resources/nehemiah-formation',
      img: article3
    },
    {
      id: '4-resilience',
      titleKey: 'resourceArticle4Title',
      authorKey: '',
      descriptionKey: 'resourceArticle4Description',
      url: '/resources/4-resilience',
      img: article4
    }
  ]

  return (
    <section className='blog'>
      <div className='container_100'>
        <div className='backImg15'>
          <img src={back} alt='' />
          <div className='text_container_dark_15'>
            <div className='h1_15'>{t("resourcesHeader")}</div>
          </div>
        </div>

        <br />
        <div className='container boxItems'>
          <h1 className='menuColor'>{t("resourcesSubtitle")}</h1>
          <br />

          {/* Замінили grid3 на адаптивну сітку з 2 колонок */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '30px'
          }}>
            {articles.map((article) => (

              <div className='box' key={article.id} style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                padding: '15px',
                border: '1px solid #eaeaea', // Легка рамка для відділення карток
                borderRadius: '8px',
                backgroundColor: '#fff'
              }}>

                {/* Ліва частина: Картинка */}
                <div className='img-container' style={{
                  flex: '0 0 160px', // Фіксована ширина для картинки (висота підлаштується автоматично)
                  overflow: 'hidden',
                  borderRadius: '6px'
                }}>
                  <Link to={article.url}>
                    <img
                      src={article.img}
                      alt={t(article.titleKey)}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    />
                  </Link>
                </div>

                {/* Права частина: Текст та посилання */}
                <div className='details' style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between' // Притискає кнопку "Читати далі" до низу
                }}>
                  <div>
                    <Link to={article.url} style={{ textDecoration: 'none' }}>
                      <h3 className='menuColor' style={{ fontSize: '1.2rem', marginBottom: '8px', lineHeight: '1.3' }}>
                        {t(article.titleKey)}
                      </h3>
                    </Link>
                    <p style={{ color: '#777', fontSize: '0.9rem', marginBottom: '12px' }}>
                      <em>{t(article.authorKey)}</em>
                    </p>
                    <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '15px' }}>
                      {t(article.descriptionKey)}
                    </p>
                  </div>

                  <Link to={article.url} className='readMore' style={{
                    fontWeight: 'bold',
                    textDecoration: 'none',
                    alignSelf: 'flex-start' // Щоб посилання не розтягувалось на всю ширину
                  }}>
                    {t("resourceReadMore")} →
                  </Link>
                </div>

              </div>
            ))}
          </div>
        </div>
        <br />
      </div>
    </section>
  )
}
